export const acquisitionsOwner = {
  name: "Junior Charles",
  role: "Acquisitions Manager"
} as const;
